import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {GuidePostComponent} from './components/guide-post/guide-post.component';
import {GuideHomeComponent} from './components/guide-home/guide-home.component';
import {RoutesEnums} from '../../enums/RoutesEnums';
import {GuideTaxonomyListComponent} from './components/guide-taxonomy-list/guide-taxonomy-list.component';

const routes: Routes = [
  {
    path: `:${RoutesEnums.TAG}/:tag/:anyParam`,
    component: GuideTaxonomyListComponent,
  },
  {path: `:${RoutesEnums.TAG}/:tag`, component: GuideTaxonomyListComponent},
  {path: ':urlPath/:anyParam', component: GuidePostComponent},
  {path: ':urlPath', component: GuidePostComponent},
  {path: '', component: GuideHomeComponent},
  {path: '**', component: GuideTaxonomyListComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GuideRoutingModule {}

export const guideRoutingComponents = [
  GuidePostComponent,
  GuideHomeComponent,
  GuideTaxonomyListComponent,
];
